import Requirement from 'developer-docs-shared-components/components/endpoint/Requirement';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import AuthTag from 'developer-docs-shared-components/components/AuthTag';
import ScopesList from 'developer-docs-shared-components/components/ScopesList';
import { StyledRequirementsPanel } from 'developer-docs-shared-components/modules/Doc/components/Doc';
import { RATE_LIMIT_DOCUMENTATION } from '../utils/urls';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Update the rate documentation to point to a doc locally in the app
const EndpointRequirements = ({
  scope
}) => {
  return /*#__PURE__*/_jsxs(StyledRequirementsPanel, {
    className: "m-top-8",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.requirements.header"
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      gap: 15,
      direction: "column",
      children: [scope && /*#__PURE__*/_jsx(Requirement, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.requirements.scopes.header.scopes"
        }),
        value: /*#__PURE__*/_jsx(ScopesList, {
          scopes: typeof scope === 'string' ? [scope] : scope
        })
      }), /*#__PURE__*/_jsx(Requirement, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.requirements.limits.header"
        }),
        value: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `developer-docs-shared-components.requirements.limits.standard_jsx`,
          options: {
            href: RATE_LIMIT_DOCUMENTATION,
            external: true
          },
          elements: {
            Link
          }
        })
      }), /*#__PURE__*/_jsx(Requirement, {
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.requirements.authMethods.header"
        }),
        value: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(AuthTag, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `developer-docs-shared-components.authTypes.PRIVATE_APPS`
            })
          }), /*#__PURE__*/_jsx(AuthTag, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `developer-docs-shared-components.authTypes.OAUTH_TOKEN`
            })
          })]
        })
      })]
    })]
  });
};
export default EndpointRequirements;